import { decrypt, encrypt, encodeBase64 } from "../utils/crypto";

const PREFIX = "@SacRPE:";

const LEGACY_HAS_SOCIAL_NAME_KEY = `${PREFIX}hasSocialName`;

export const storageService = {

 KEYS : {
  // --- SESSION STORAGE (Isolamento por Aba) ---
  CLIENT: encodeBase64(`${PREFIX}client`), 
  // --- LOCAL STORAGE (Persistência Global) ---
  TOKEN: `${PREFIX}token`,
  REFRESH_TOKEN: `${PREFIX}refreshToken`,
  SESSION_ID: `${PREFIX}sessionId`,
  TICKET_PROTOCOL: `${PREFIX}ticketProtocol`,
  IDENTITY: `${PREFIX}identity`,
  ENV: `${PREFIX}env`,
  ALLOW_ACCESS: `${PREFIX}allowAccess`,
  IS_PCH: `${PREFIX}isPch`,
  PWD_EXPIRED: `${PREFIX}passwordExpired`,
  IS_CPF_REQUIRED: `${PREFIX}isCpfRequired`,
  COMPANY: `${PREFIX}company`,
  SOLICITATION: `${PREFIX}solicitation`,
  LAST_ACTIVITY: `${PREFIX}lastActivity`
},
  
  // --- GETTERS  --- //

  getToken(): string | null {
    return localStorage.getItem(this.KEYS.TOKEN);
  },

  getIdentity(): string | null {
    return localStorage.getItem(this.KEYS.IDENTITY);
  },

  getLastActivity(): number {
    const data = localStorage.getItem(this.KEYS.LAST_ACTIVITY);
    return data ? parseInt(data, 10) : 0;
  },

  getIsPch(): boolean | null {
    const data = localStorage.getItem(this.KEYS.IS_PCH);
    return data ? JSON.parse(data) : false;
  },

  getSessionID(): string | null {
    return localStorage.getItem(this.KEYS.SESSION_ID);
  },

  getEnv(): any | null {
    const data = localStorage.getItem(this.KEYS.ENV);
    return data ? JSON.parse(data) : null;
  },

  getPasswordExpired(): { isPwdExpired: boolean; firstLogin: boolean } | null {
    const data = localStorage.getItem(this.KEYS.PWD_EXPIRED);
    return data ? JSON.parse(data) : null;
  },

  getCpfRequired(): boolean {
    const data = localStorage.getItem(this.KEYS.IS_CPF_REQUIRED);
    return data ? JSON.parse(data) : false;
  },

  getAllowAccess(): boolean {
    const data = localStorage.getItem(this.KEYS.ALLOW_ACCESS);
    return data ? JSON.parse(data) : false;
  },

  getSolicitation(): any | null {
    const data = localStorage.getItem(this.KEYS.SOLICITATION);
    return data ? JSON.parse(data) : null;
  },

  getTicketProtocol(): string | null {
    const data = sessionStorage.getItem(this.KEYS.TICKET_PROTOCOL);
    return data ? JSON.parse(data) : null;
  },

  getClient(): any | null {
    const encrypted = sessionStorage.getItem(this.KEYS.CLIENT);
    if (!encrypted) return null;
    try {
      return JSON.parse(decrypt(encrypted));
    } catch (e) {
      console.error("Erro ao descriptografar portador", e);
      return null;
    }
  },

    // --- SETTERS  --- //

  setCpfRequired(required: boolean) {
    localStorage.setItem(this.KEYS.IS_CPF_REQUIRED, JSON.stringify(required));
  },

  setSolicitation(item: any) {
    localStorage.setItem(this.KEYS.SOLICITATION, JSON.stringify(item));
  },

  setLastActivity() {
    localStorage.setItem(this.KEYS.LAST_ACTIVITY, Date.now().toString());
  },
  
  removeSolicitation() {
    localStorage.removeItem(this.KEYS.SOLICITATION);
  },

  removeTicketProtocol() {
    sessionStorage.removeItem(this.KEYS.TICKET_PROTOCOL);
  },

  clearLegacySocialNameFlag() {
    localStorage.removeItem(LEGACY_HAS_SOCIAL_NAME_KEY);
  },

  setAuthData(data: {
    token: string;
    refreshToken: string;
    env: any;
    identity: string;
    passwordExpired: boolean;
    isPch: boolean;
    sessionId: string;
    allowAccess: boolean;
  }) {
    this.clearLegacySocialNameFlag();
    localStorage.setItem(this.KEYS.TOKEN, data.token);
    localStorage.setItem(this.KEYS.REFRESH_TOKEN, data.refreshToken);
    localStorage.setItem(this.KEYS.IDENTITY, data.identity);
    localStorage.setItem(this.KEYS.SESSION_ID, data.sessionId);
    localStorage.setItem(this.KEYS.ENV, JSON.stringify(data.env));
    localStorage.setItem(this.KEYS.PWD_EXPIRED, JSON.stringify(data.passwordExpired));
    localStorage.setItem(this.KEYS.IS_PCH, JSON.stringify(data.isPch));
    localStorage.setItem(this.KEYS.ALLOW_ACCESS, JSON.stringify(data.allowAccess));
  },

  setTicketProtocol(ticketProtocol: any) {
    sessionStorage.setItem(this.KEYS.TICKET_PROTOCOL, JSON.stringify(ticketProtocol));
  },

  setClient(data: any) {
    const ciphertext = encrypt(JSON.stringify(data));
    sessionStorage.setItem(this.KEYS.CLIENT, ciphertext);
  },



  clearAttendance() {
    sessionStorage.removeItem(this.KEYS.CLIENT);
  },

  clearAll() {
    localStorage.clear();
    sessionStorage.clear();
    this.clearLegacySocialNameFlag();
  }
};